import { render } from "./StudentPaymentFields.vue?vue&type=template&id=603e7a3c&lang=pug"
import script from "./StudentPaymentFields.vue?vue&type=script&lang=js"
export * from "./StudentPaymentFields.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__